import React, { useEffect } from "react";
import "./IntroPage.style.css";
import ExpandableCard from "../../Components/ExpandableCard/ExpandableCard";
import Data from "../../Assets/Content/ContentData.js";
import EconomySwitch from "../../Components/EconomySwitch/EconomySwitch";

// Import images
import kreisImg from "../../Assets/Images/kreis.png"; // For Kreislaufwirtschaft
import linieImg from "../../Assets/Images/linie.png"; // For Linearwirtschaft

const IntroPage = (props) => {
  const { economyType } = props.AppStateService;
  const { activeCard, circularEconomyState, onChangeEconomySwitch } = props;

  useEffect(() => {
    document.title = "Kreislaufwirtschaftsguide | Intro";
  }, []);

  const isLinear = economyType === "linear";

  const cardsData = [
    {
      key: "Main",
      title: isLinear ? Data.LinearMain.heading : Data.CycleMain.heading,
      image: isLinear ? linieImg : kreisImg,
      video: isLinear
        ? null
        : process.env.PUBLIC_URL +
          "/Videos/Was_ist_Kreislaufwirtschaft_Final.mp4",
      content: isLinear ? Data.LinearMain.text : Data.CycleMain.text,
      layout: "three-column",
    },
    {
      key: "Ressourcen",
      title: "Ressourcen",
      image: process.env.PUBLIC_URL + "/ressourcen.png",
      content: Data.Ressourcen.text,
      video: process.env.PUBLIC_URL + "/Videos/MDZ Video_Rueckgewinnung.mp4",
      aiContent: Data.Ressourcen.aiText,
      exampleContent: Data.Ressourcen.example,
    },
    {
      key: "EcoDesign",
      title: "Eco-Design",
      image: process.env.PUBLIC_URL + "/ecosdesign.png",
      content: Data.EcoDesign.text,
      video: process.env.PUBLIC_URL + "/Videos/MDZ Video_ecodesign.mp4",
      aiContent: Data.EcoDesign.aiText,
      exampleContent: Data.EcoDesign.example,
    },
    {
      key: "Produktion",
      title: "Produktion",
      image: process.env.PUBLIC_URL + "/produktion.png",
      content: Data.Produktion.text,
      aiContent: Data.Produktion.aiText,
      examplesContent: Data.Produktion.examples,
    },
    {
      key: "Vertrieb",
      title: "Vertrieb",
      image: process.env.PUBLIC_URL + "/vertrieb.png",
      content: Data.Vertrieb.text,
      aiContent: Data.Vertrieb.aiText,
      exampleContent: Data.Vertrieb.example,
    },
    {
      key: "Nutzung",
      title: "Nutzung",
      image: process.env.PUBLIC_URL + "/nutzung.png",
      content: Data.Nutzung.text,
      video: process.env.PUBLIC_URL + "/Videos/MDZ Video_Nutzung.mp4",
      aiContent: Data.Nutzung.aiText,
      exampleContent: Data.Nutzung.example,
    },
    {
      key: "Nutzungsende",
      title: "Nutzungsende",
      image: process.env.PUBLIC_URL + "/nutzungsende.png",
      content: Data.Nutzungsende.text,
      aiContent: Data.Nutzungsende.aiText,
      exampleContent: Data.Nutzungsende.example,
    },
    {
      key: "Recycling",
      title: "Recycling",
      image: process.env.PUBLIC_URL + "/recycling.png",
      content: Data.Recycling.text,
      video: process.env.PUBLIC_URL + "/Videos/MDZ Video_Recycling.mp4",
      aiContent: Data.Recycling.aiText,
      exampleContent: Data.Recycling.example,
    },
  ];

  return (
    <div className="container mt-4 mb-5">
      <div className="row justify-content-center">
        <div className="col-lg-12">
          {cardsData.map((card, index) => {
            const isMain = card.key === "Main";
            return (
              <ExpandableCard
                key={index}
                title={card.title}
                content={card.content}
                image={isMain ? null : card.image}
                video={isMain ? null : card.video}
                aiContent={card.aiContent}
                exampleContent={card.exampleContent}
                examplesContent={card.examplesContent}
                initiallyOpen={
                  activeCard ? card.key === activeCard : index === 0
                } // Open active card if set, otherwise first card
                layout={isMain ? "standard" : card.layout}
              >
                {isMain ? (
                  <>
                    <div className="sticky-switch-container">
                      <EconomySwitch
                        onChangeEconomySwitch={onChangeEconomySwitch}
                        circularEconomyState={circularEconomyState}
                      />
                    </div>

                    <div className="row align-items-start mb-4">
                      {/* Left Column: Image and Video */}
                      <div className="col-md-6 mb-3 mb-md-0 d-flex flex-column align-items-center justify-content-start">
                        {card.image && (
                          <img
                            src={card.image}
                            alt={card.title}
                            className="img-fluid rounded shadow-sm mb-4"
                            style={{
                              maxHeight: "600px",
                              maxWidth: "100%",
                              objectFit: "contain",
                            }}
                          />
                        )}

                        {card.video && (
                          <div className="w-100">
                            <h6
                              className="text-uppercase text-muted mb-2 text-center"
                              style={{
                                letterSpacing: "1px",
                                fontSize: "0.75rem",
                              }}
                            >
                              Video zum Thema
                            </h6>
                            <video
                              src={card.video}
                              controls
                              style={{
                                width: "100%",
                                height: "auto",
                                borderRadius: "8px",
                                border: "1px solid #eee",
                                boxShadow: "0 4px 6px rgba(0,0,0,0.1)",
                                backgroundColor: "#000",
                              }}
                            >
                              Ihr Browser unterstützt das Video-Tag nicht.
                            </video>
                          </div>
                        )}
                      </div>

                      {/* Right Column: Text */}
                      <div className="col-md-6">
                        <div
                          className="card-text-content w-100"
                          style={{ textAlign: "justify", lineHeight: "1.6" }}
                          dangerouslySetInnerHTML={{ __html: card.content }}
                        />
                      </div>
                    </div>
                  </>
                ) : null}
              </ExpandableCard>
            );
          })}
        </div>
      </div>
    </div>
  );
};

export default IntroPage;
